import { render, staticRenderFns } from "./EntityLabel.vue?vue&type=template&id=446879fc&scoped=true&"
import script from "./EntityLabel.vue?vue&type=script&lang=js&"
export * from "./EntityLabel.vue?vue&type=script&lang=js&"
import style0 from "./EntityLabel.vue?vue&type=style&index=0&id=446879fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446879fc",
  null
  
)

export default component.exports